export default function CustomDateCellWrapper({ children, value, events, currentView }) {
  const count = events.filter(
    (e) => new Date(e.start).toDateString() === value.toDateString()
  ).length;

  return (
    <div style={{ position: "relative", height: "100%" }}>
      {children}
      {currentView === "month" && count > 1 && (
        <div style={{
          position: "absolute",
          top: 2,
          right: 4,
          fontSize: 13,
          backgroundColor: "#007bff",
          color: "#fff",
          borderRadius: "12px",
          padding: "2px 6px",
          fontWeight: 600,
        }}>
          {count}
        </div>
      )}
    </div>
  );
}
